var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('landingPage'),_c('featuredPro'),_c('discoverLanding'),_c('ourProject'),_c('freQuent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }